import { drilldownWidgetData, exportWidgetData, fetchSlicerOptions, hydrateWidgetData } from './api'
import type { DashboardDataSource } from './dataSource'
import { useAgentBuilderDrilldownHierarchyQuery } from './hooks'

function useAppDrilldownHierarchy(clientId: string, platformTypeId: number) {
  return useAgentBuilderDrilldownHierarchyQuery(clientId, platformTypeId).data ?? null
}

export const appDashboardDataSource: DashboardDataSource = {
  hydrateWidget: hydrateWidgetData,
  slicerOptions: fetchSlicerOptions,
  drilldownWidget: drilldownWidgetData,
  exportWidget: exportWidgetData,
  useDrilldownHierarchy: useAppDrilldownHierarchy,
}
